import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, pricing } from '../data/content';
export function Bonuses() {
  return <section className="bg-paper py-20 sm:py-24" aria-labelledby="bonuses-title" data-id="element-21" data-mp="pioawsk4rebp">
      <div className="mx-auto max-w-[920px] px-5 sm:px-8" data-id="element-22" data-mp="au1usomoiijf">
        <div className="text-center" data-id="element-23" data-mp="fu6dmlb27pct">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-24" data-mp="ft4pbf5196d5">Y aún hay más</p>
          <h2 id="bonuses-title" className="mt-4 text-balance font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-25" data-mp="1tc0jpd2h07t">
            Recibe 5 bonos profesionales <em className="text-terra" data-id="element-26" data-mp="3o1lfsst9nnjz">GRATIS</em>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-27" data-mp="3o3g0c60mldnj">
            Recursos complementarios diseñados para ayudarte a preparar, organizar y conducir tus sesiones con mayor
            claridad. Incluidos sin costo adicional con tu acceso a Maestro de Sesiones.
          </p>
        </div>

        <ul className="mt-12 space-y-5" data-id="element-28" data-mp="1r6z2nocgtzp6">
          {bonuses.map(b => <li key={b.label} className="grid gap-x-10 gap-y-5 rounded-[2rem] bg-white p-6 ring-1 ring-cream-line sm:p-8 md:grid-cols-[200px_1fr] md:items-center" data-id="element-29" data-mp="3id54x7cwv5bb">
              <div className="mx-auto w-full max-w-[220px] md:max-w-none" data-id="element-30" data-mp="3r6i3opxnp15b">
                <img src={b.coverImage} alt={`Portada del ${b.label.replace('#', '')}: ${b.name}`} width={b.coverWidth} height={b.coverHeight} loading="lazy" className="block h-auto w-full" data-id="element-31" data-mp="3r8ktb8uwcs9i" />
              </div>
              <div data-id="element-32" data-mp="2ughbsi1zq4js">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-terra-wash px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-terra-deep" data-id="element-33" data-mp="2uh95fnc11s7f">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="33h5on9fndyv3" />
                  {b.label}
                </span>
                <h3 className="mt-3 font-display text-2xl leading-tight text-petrol sm:text-[1.75rem]" data-id="element-35" data-mp="np8denoybnmf">{b.name}</h3>
                <p className="mt-3 leading-relaxed text-ink-soft" data-id="element-36" data-mp="ipwvvcgrge3s">{b.description}</p>
                <div className="mt-5 flex flex-wrap items-center gap-3" data-id="element-37" data-mp="3cjpo6yy68uo3">
                  <span className="text-sm text-ink-mute" data-id="element-38" data-mp="3hhzofnyr6lgk">
                    Valor: 
                  </span>
                  <span className="rounded-md bg-sage-wash px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-sage-deep" data-id="element-39" data-mp="3lj31y3tbw5em">
                    Gratis hoy
                  </span>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 rounded-[2rem] bg-petrol px-6 py-9 text-center text-paper sm:px-10" data-id="element-40" data-mp="2tqc3rns346mq">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-cream/70" data-id="element-41" data-mp="2xrxo1u6y7n6y">
            Valor total de los 5 bonos: <s className="text-cream/90 decoration-terra-soft" data-id="element-42" data-mp="37jtld317n9a4">{pricing.bonusTotal}</s>
          </p>
          <p className="mx-auto mt-4 max-w-xl text-balance font-display text-2xl leading-snug sm:text-3xl" data-id="element-43" data-mp="2a4fsrooh66z8">
            Hoy los recibís <em className="text-terra-soft" style={{
            fontSize: "32px"
          }} data-id="element-44" data-mp="2f2qxxm3trtb4">todos gratis</em> con Maestro de Sesiones
          </p>
        </div>
      </div>
    </section>;
}